import React, { useEffect, useState } from 'react'
import GroupSelect from './components/GroupSelect'
import RideList from './components/RideList'
import FilterBar, { RideTypeFilter } from './components/FilterBar'
import TimeFilter from './components/TimeFilter'
import WhatsAppTemplates from './components/WhatsAppTemplates'
import { Plus, X } from 'lucide-react'

export default function App() {
  var [hasGroup, setHasGroup] = useState(false)
  var [isComposerOpen, setIsComposerOpen] = useState(false)
  var [editingRide, setEditingRide] = useState(null)

  function requestPublish() {
    if (!localStorage.getItem('carpool_token')) {
      if (typeof window.showAuthModal === 'function') window.showAuthModal()
      return
    }
    setEditingRide(null)
    setIsComposerOpen(true)
  }

  function requestEdit(ride) {
    setEditingRide(ride)
    setIsComposerOpen(true)
  }

  function requestVerification() {
    setIsComposerOpen(false)
    if (typeof window.showAuthModal === 'function') window.showAuthModal()
  }

  useEffect(function () {
    function check() {
      var jid = window.selectedGroup || ''
      if (window.legacyStore && typeof window.legacyStore.getSelectedGroup === 'function') {
        jid = window.legacyStore.getSelectedGroup() || jid
      }
      setHasGroup(!!jid)
    }
    check()
    var interval = setInterval(check, 500)
    var unsub = null
    if (window.legacyStore && typeof window.legacyStore.subscribe === 'function') {
      unsub = window.legacyStore.subscribe(function (key) {
        if (key === 'selectedGroup') check()
      })
    }
    return function () {
      clearInterval(interval)
      if (typeof unsub === 'function') unsub()
    }
  }, [])

  return (
    <div className="h-screen bg-slate-50 flex flex-col md:flex-row">
      {/* Sidebar: group + rides (desktop left panel, mobile full width below) */}
      <aside className="w-full md:w-[400px] md:border-r md:border-slate-200 flex-1 md:flex-none min-h-0 md:h-screen md:overflow-y-auto bg-white flex flex-col">
        {/* Header + group select */}
        <div className="px-4 pt-3 pb-2 border-b border-slate-100 space-y-2">
          <div className="flex items-center gap-2">
            <img src="/assets/icons/favicon-transparent.png?v=11" alt="PoliPool" className="size-5 rounded-full" />
            <span className="text-base font-bold text-slate-900">PoliPool</span>
            <a href="https://beacons.ai/poliapps" target="_blank" className="text-xs text-slate-400 ml-auto hover:text-slate-600 no-underline">por poliapps</a>
          </div>
          <GroupSelect />
        </div>

        {/* Direction filter */}
        {hasGroup && (
          <div className="px-4 pt-3 pb-2 border-b border-slate-100 space-y-3">
            <div>
              <div className="text-xs font-semibold text-slate-500 mb-2">Dirección</div>
              <FilterBar />
            </div>
            <div>
              <div className="text-xs font-semibold text-slate-500 mb-2">Tipo de viaje</div>
              <RideTypeFilter />
            </div>
            <div>
              <div className="text-xs font-semibold text-slate-500 mb-2">Horario</div>
              <TimeFilter />
            </div>
          </div>
        )}

        {hasGroup && <div className="px-4 py-3 border-b border-slate-100">
          <button type="button" onClick={requestPublish} className="flex h-9 w-full items-center justify-center gap-2 rounded-lg bg-slate-900 text-xs font-semibold text-white transition-colors hover:bg-slate-800">
            <Plus className="size-4" /> Publicar viaje
          </button>
        </div>}

        {/* Ride list */}
        <div className="flex-1 overflow-y-auto">
          <RideList onEdit={requestEdit} />
        </div>
      </aside>
      {isComposerOpen && <div className="fixed inset-0 z-50 flex items-end bg-slate-950/35 md:items-center md:justify-center" role="dialog" aria-modal="true" aria-label="Publicar viaje" onMouseDown={function () { setIsComposerOpen(false) }}>
        <div className="w-full rounded-t-2xl bg-white shadow-2xl md:max-w-sm md:rounded-2xl" onMouseDown={function (event) { event.stopPropagation() }}>
          <div className="flex items-center border-b border-slate-100 px-4 py-3">
            <div>
              <h2 className="text-sm font-bold text-slate-900">{editingRide ? 'Editar viaje' : 'Publicar viaje'}</h2>
              <p className="text-[11px] text-slate-500">{editingRide ? 'Solo tú puedes modificar esta publicación.' : 'Se mostrará en este grupo de PoliPool.'}</p>
            </div>
            <button type="button" onClick={function () { setIsComposerOpen(false) }} className="ml-auto rounded-md p-1.5 text-slate-500 hover:bg-slate-100" aria-label="Cerrar"><X className="size-4" /></button>
          </div>
          <WhatsAppTemplates editingRide={editingRide} onPublished={function () { setIsComposerOpen(false); setEditingRide(null) }} onAuthRequired={requestVerification} />
        </div>
      </div>}
    </div>
  )
}
